<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 200 80" xmlns="http://www.w3.org/2000/svg"
    class="autozaki-logo">
    <g class="autozaki-gear">
        <circle cx="24" cy="40" r="16" fill="none" stroke="var(--sidebar-active, #00c2ff)" stroke-width="2" />
        <circle cx="24" cy="40" r="5" fill="var(--sidebar-active, #00c2ff)" class="autozaki-gear-pulse" />
        <g stroke="var(--sidebar-active, #00c2ff)" stroke-width="3" stroke-linecap="round">
            <line x1="24" y1="20" x2="24" y2="26" />
            <line x1="24" y1="54" x2="24" y2="60" />
            <line x1="4" y1="40" x2="10" y2="40" />
            <line x1="38" y1="40" x2="44" y2="40" />
            <line x1="10.3" y1="26.3" x2="14.5" y2="30.5" />
            <line x1="33.5" y1="49.5" x2="37.7" y2="53.7" />
            <line x1="37.7" y1="26.3" x2="33.5" y2="30.5" />
            <line x1="14.5" y1="49.5" x2="10.3" y2="53.7" />
        </g>
    </g>

    <text x="56" y="46" class="autozaki-text" letter-spacing="1.5">
        <tspan class="autozaki-letter l1">A</tspan>
        <tspan class="autozaki-letter l2">U</tspan>
        <tspan class="autozaki-letter l3">T</tspan>
        <tspan class="autozaki-letter l4">O</tspan>
        <tspan class="autozaki-letter l5 accent">Z</tspan>
        <tspan class="autozaki-letter l6 accent">A</tspan>
        <tspan class="autozaki-letter l7 accent">K</tspan>
        <tspan class="autozaki-letter l8 accent">I</tspan>
    </text>

    <line x1="56" y1="56" x2="186" y2="56" class="autozaki-underline" />
</svg>